import { useFormikContext } from "formik";

const useRequestedProductType = () => {
  const { values: { requestedProductType } } = useFormikContext();

  return requestedProductType;
};

export default useRequestedProductType;